import React from 'react';
import { Instagram, Facebook, Youtube, Music2 } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-stone-900 text-stone-300 py-12 border-t border-stone-800" data-id="element-30">
      <div className="container mx-auto px-6 md:px-12" data-id="element-31">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-32">
          <div className="text-center md:text-left" data-id="element-33">
            <h3 className="font-serif text-2xl text-white font-semibold mb-2" data-id="element-34">
              Cocina y Dulces Rentables
            </h3>
            <p className="text-stone-500 text-sm" data-id="element-35">
              Transformando cocinas en negocios exitosos.
            </p>
          </div>

          <div className="flex items-center gap-6" data-id="element-36">
            <a href="#" className="text-stone-400 hover:text-[#C9A96E] transition-colors" data-id="element-37">
              <Instagram size={24} strokeWidth={1.5} data-id="element-38" />
              <span className="sr-only" data-id="element-39">Instagram</span>
            </a>
            <a href="#" className="text-stone-400 hover:text-[#C9A96E] transition-colors" data-id="element-40">
              <Facebook size={24} strokeWidth={1.5} data-id="element-41" />
              <span className="sr-only" data-id="element-42">Facebook</span>
            </a>
            <a href="#" className="text-stone-400 hover:text-[#C9A96E] transition-colors" data-id="element-43">
              <Youtube size={24} strokeWidth={1.5} data-id="element-44" />
              <span className="sr-only" data-id="element-45">YouTube</span>
            </a>
            <a href="#" className="text-stone-400 hover:text-[#C9A96E] transition-colors" data-id="element-46">
              <Music2 size={24} strokeWidth={1.5} data-id="element-47" />
              <span className="sr-only" data-id="element-48">TikTok</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-stone-800 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-stone-500" data-id="element-49">
          <p data-id="element-50">
            &copy; {currentYear} Cocina y Dulces Rentables. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-51">
            <a href="#" className="hover:text-stone-300 transition-colors" data-id="element-52">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-stone-300 transition-colors" data-id="element-53">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}